import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import {
  Profile, Basket, Checkout, Login, Orders, PasswordRetrieval, Search, UserData,
} from './flow/pages';
import { Modal, BasketBar, Sidebar } from './flow/components';

export default function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/map" component={Search} />
        <Route path="/map/:addressId" component={Search} />
        <Route path="/basket" component={Basket} />
        <Route path="/checkout" component={Checkout} />
        <Route path="/login" component={Login} />
        <Route path="/orders" component={Orders} />
        <Route path="/userData" component={UserData} />
        <Route path="/passwordRetrieval/:token" component={PasswordRetrieval} />
        <Route exact path="/:nickname" component={Profile} />
        <Route path="/:nickname/offers/:offerId" component={Profile} />
      </Switch>

      <Sidebar />
      {/* <Modal /> */}
      <BasketBar />
    </BrowserRouter>
  );
}
